export const StatesListBrazil = {
  UF: [
    { nome: 'Acre', sigla: 'AC' },
    { nome: 'Alagoas', sigla: 'AL' },
    { nome: 'Amapá', sigla: 'AP' },
    { nome: 'Amazonas', sigla: 'AM' },
    { nome: 'Bahia', sigla: 'BA' },
    { nome: 'Ceará', sigla: 'CE' },
    { nome: 'Distrito Federal', sigla: 'DF' },
    { nome: 'Espírito Santo', sigla: 'ES' },
    { nome: 'Goiás', sigla: 'GO' },
    { nome: 'Maranhão', sigla: 'MA' },
    { nome: 'Mato Grosso', sigla: 'MT' },
    { nome: 'Mato Grosso do Sul', sigla: 'MS' },
    { nome: 'Minas Gerais', sigla: 'MG' },
    { nome: 'Pará', sigla: 'PA' },
    { nome: 'Paraíba', sigla: 'PB' },
    { nome: 'Paraná', sigla: 'PR' },
    { nome: 'Pernambuco', sigla: 'PE' },
    { nome: 'Piauí', sigla: 'PI' },
    { nome: 'Rio de Janeiro', sigla: 'RJ' },
    { nome: 'Rio Grande do Norte', sigla: 'RN' },
    { nome: 'Rio Grande do Sul', sigla: 'RS' },
    { nome: 'Rondônia', sigla: 'RO' },
    { nome: 'Roraima', sigla: 'RR' },
    { nome: 'Santa Catarina', sigla: 'SC' },
    { nome: 'São Paulo', sigla: 'SP' },
    { nome: 'Sergipe', sigla: 'SE' },
    { nome: 'Tocantins', sigla: 'TO' }

  ]
};

// Icones
export const IconsThemify = [
  { name: 'ti-arrow-up' },
  { name: 'ti-arrow-right' },
  { name: 'ti-arrow-left' },
  { name: 'ti-arrow-down' },
  { name: 'ti-arrows-vertical' },
  { name: 'ti-arrows-horizontal' },
  { name: 'ti-angle-up' },
  { name: 'ti-angle-up' },
  { name: 'ti-angle-left' },
  { name: 'ti-angle-down' },
  { name: 'ti-angle-double-up' },
  { name: 'ti-angle-double-up' },
  { name: 'ti-angle-double-left' },
  { name: 'ti-angle-double-down' },
  { name: 'ti-move' },
  { name: 'ti-fullscreen' },
  { name: 'ti-arrow-top-right' },
  { name: 'ti-arrow-top-left' },
  { name: 'ti-arrow-circle-up' },
  { name: 'ti-arrow-circle-right' },
  { name: 'ti-arrow-circle-left' },
  { name: 'ti-arrow-circle-down' },
  { name: 'ti-arrows-corner' },
  { name: 'ti-split-v' },
  { name: 'ti-split-v-alt' },
  { name: 'ti-split-h' },
  { name: 'ti-hand-point-up' },
  { name: 'ti-hand-point-right' },
  { name: 'ti-hand-point-left' },
  { name: 'ti-hand-point-down' },
  { name: 'ti-back-right' },
  { name: 'ti-back-left' },
  { name: 'ti-exchange-vertical' },
  { name: 'ti-wand' },
  { name: 'ti-save' },
  { name: 'ti-save-alt' },
  { name: 'ti-save-alt' },
  { name: 'ti-direction-alt' },
  { name: 'ti-user' },
  { name: 'ti-link' },
  { name: 'ti-unlink' },
  { name: 'ti-trash' },
  { name: 'ti-target' },
  { name: 'ti-tag' },
  { name: 'ti-desktop' },
  { name: 'ti-tablet' },
  { name: 'ti-mobile' },
  { name: 'ti-email' },
  { name: 'ti-star' },
  { name: 'ti-spray' },
  { name: 'ti-signal' },
  { name: 'ti-shopping-cart' },
  { name: 'ti-shopping-cart-full' },
  { name: 'ti-settings' },
  { name: 'ti-search' },
  { name: 'ti-zoom-in' },
  { name: 'ti-zoom-out' },
  { name: 'ti-cut' },
  { name: 'ti-ruler' },
  { name: 'ti-ruler-alt-2' },
  { name: 'ti-ruler-pencil' },
  { name: 'ti-ruler-alt' },
  { name: 'ti-bookmark' },
  { name: 'ti-bookmark-alt' },
  { name: 'ti-reload' },
  { name: 'ti-plus' },
  { name: 'ti-minus' },
  { name: 'ti-close' },
  { name: 'ti-pin' },
  { name: 'ti-pencil' },
  { name: 'ti-pencil-alt' },
  { name: 'ti-paint-roller' },
  { name: 'ti-paint-bucket' },
  { name: 'ti-na' },
  { name: 'ti-medall' },
  { name: 'ti-medall-alt' },
  { name: 'ti-marker' },
  { name: 'ti-marker-alt' },
  { name: 'ti-layers-alt' },
  { name: 'ti-key' },
  { name: 'ti-image' },
  { name: 'ti-heart' },
  { name: 'ti-heart-broken' },
  { name: 'ti-hand-stop' },
  { name: 'ti-hand-open' },
  { name: 'ti-hand-drag' },
  { name: 'ti-flag-alt' },
  { name: 'ti-flag-alt-2' },
  { name: 'ti-eye' },
  { name: 'ti-import' },
  { name: 'ti-export' },
  { name: 'ti-cup' },
  { name: 'ti-crown' },
  { name: 'ti-comments' },
  { name: 'ti-comment' },
  { name: 'ti-comment-alt' },
  { name: 'ti-thought' },
  { name: 'ti-clip' },
  { name: 'ti-check' },
  { name: 'ti-check-box' },
  { name: 'ti-camera' },
  { name: 'ti-announcement' },
  { name: 'ti-brush' },
  { name: 'ti-brush-alt' },
  { name: 'ti-palette' },
  { name: 'ti-briefcase' },
  { name: 'ti-bolt' },
  { name: 'ti-bolt-alt' },
  { name: 'ti-blackboard' },
  { name: 'ti-bag' },
  { name: 'ti-world' },
  { name: 'ti-wheelchair' },
  { name: 'ti-car' },
  { name: 'ti-truck' },
  { name: 'ti-timer' },
  { name: 'ti-ticket' },
  { name: 'ti-thumb-up' },
  { name: 'ti-thumb-down' },
  { name: 'ti-stats-up' },
  { name: 'ti-stats-down' },
  { name: 'ti-shine' },
  { name: 'ti-shift-right' },
  { name: 'ti-shift-left' },
  { name: 'ti-shift-right-alt' },
  { name: 'ti-shift-left-alt' },
  { name: 'ti-shield' },
  { name: 'ti-notepad' },
  { name: 'ti-server' },
  { name: 'ti-pulse' },
  { name: 'ti-printer' },
  { name: 'ti-power-off' },
  { name: 'ti-plug' },
  { name: 'ti-pie-chart' },
  { name: 'ti-panel' },
  { name: 'ti-package' },
  { name: 'ti-music' },
  { name: 'ti-music-alt' },
  { name: 'ti-mouse' },
  { name: 'ti-mouse-alt' },
  { name: 'ti-money' },
  { name: 'ti-microphone' },
  { name: 'ti-menu' },
  { name: 'ti-menu-alt' },
  { name: 'ti-map' },
  { name: 'ti-map-alt' },
  { name: 'ti-location-pin' },
  { name: 'ti-light-bulb' },
  { name: 'ti-info' },
  { name: 'ti-infinite' },
  { name: 'ti-id-badge' },
  { name: 'ti-hummer' },
  { name: 'ti-home' },
  { name: 'ti-help' },
  { name: 'ti-headphone' },
  { name: 'ti-harddrives' },
  { name: 'ti-harddrive' },
  { name: 'ti-gift' },
  { name: 'ti-game' },
  { name: 'ti-filter' },
  { name: 'ti-files' },
  { name: 'ti-file' },
  { name: 'ti-zip' },
  { name: 'ti-folder' },
  { name: 'ti-envelope' },
  { name: 'ti-dashboard' },
  { name: 'ti-cloud' },
  { name: 'ti-cloud-up' },
  { name: 'ti-cloud-down' },
  { name: 'ti-cloud-down' },
  { name: 'ti-calendar' },
  { name: 'ti-book' },
  { name: 'ti-bell' },
  { name: 'ti-basketball' },
  { name: 'ti-bar-chart' },
  { name: 'ti-bar-chart-alt' },
  { name: 'ti-archive' },
  { name: 'ti-anchor' },
  { name: 'ti-alert' },
  { name: 'ti-alarm-clock' },
  { name: 'ti-agenda' },
  { name: 'ti-write' },
  { name: 'ti-wallet' },
  { name: 'ti-video-clapper' },
  { name: 'ti-video-camera' },
  { name: 'ti-vector' },
  { name: 'ti-support' },
  { name: 'ti-stamp' },
  { name: 'ti-slice' },
  { name: 'ti-shortcode' },
  { name: 'ti-receipt' },
  { name: 'ti-pin2' },
  { name: 'ti-pin-alt' },
  { name: 'ti-pencil-alt2' },
  { name: 'ti-eraser' },
  { name: 'ti-more' },
  { name: 'ti-more-alt' },
  { name: 'ti-microphone-alt' },
  { name: 'ti-magnet' },
  { name: 'ti-line-double' },
  { name: 'ti-line-dotted' },
  { name: 'ti-line-dashed' },
  { name: 'ti-ink-pen' },
  { name: 'ti-info-alt' },
  { name: 'ti-help-alt' },
  { name: 'ti-headphone-alt' },
  { name: 'ti-gallery' },
  { name: 'ti-face-smile' },
  { name: 'ti-face-sad' },
  { name: 'ti-credit-card' },
  { name: 'ti-comments-smiley' },
  { name: 'ti-time' },
  { name: 'ti-share' },
  { name: 'ti-share-alt' },
  { name: 'ti-rocket' },
  { name: 'ti-new-window' },
  { name: 'ti-rss' },
  { name: 'ti-rss-alt' },
  { name: 'ti-control-stop' },
  { name: 'ti-control-shuffle' },
  { name: 'ti-control-play' },
  { name: 'ti-control-pause' },
  { name: 'ti-control-forward' },
  { name: 'ti-control-backward' },
  { name: 'ti-volume' },
  { name: 'ti-control-skip-forward' },
  { name: 'ti-control-skip-backward' },
  { name: 'ti-control-record' },
  { name: 'ti-control-eject' },
  { name: 'ti-paragraph' },
  { name: 'ti-uppercase' },
  { name: 'ti-underline' },
  { name: 'ti-text' },
  { name: 'ti-Italic' },
  { name: 'ti-smallcap' },
  { name: 'ti-list' },
  { name: 'ti-list-ol' },
  { name: 'ti-align-right' },
  { name: 'ti-align-left' },
  { name: 'ti-align-justify' },
  { name: 'ti-align-center' },
  { name: 'ti-quote-right' },
  { name: 'ti-quote-left' },
  { name: 'ti-layout-width-full' },
  { name: 'ti-layout-width-default' },
  { name: 'ti-layout-width-default-alt' },
  { name: 'ti-layout-tab' },
  { name: 'ti-layout-tab-window' },
  { name: 'ti-layout-tab-v' },
  { name: 'ti-layout-tab-min' },
  { name: 'ti-layout-slider' },
  { name: 'ti-layout-slider-alt' },
  { name: 'ti-layout-sidebar-right' },
  { name: 'ti-layout-sidebar-none' },
  { name: 'ti-layout-sidebar-left' },
  { name: 'ti-layout-placeholder' },
  { name: 'ti-layout-menu' },
  { name: 'ti-layout-menu-v' },
  { name: 'ti-layout-menu-separated' },
  { name: 'ti-layout-menu-full' },
  { name: 'ti-layout-media-right' },
  { name: 'ti-layout-media-right' },
  { name: 'ti-layout-media-overlay' },
  { name: 'ti-layout-media-overlay-alt' },
  { name: 'ti-layout-media-overlay-alt-2' },
  { name: 'ti-layout-media-left' },
  { name: 'ti-layout-media-left' },
  { name: 'ti-layout-media-center' },
  { name: 'ti-layout-media-center-alt' },
  { name: 'ti-layout-list-thumb' },
  { name: 'ti-layout-list-thumb-alt' },
  { name: 'ti-layout-list-post' },
  { name: 'ti-layout-list-large-image' },
  { name: 'ti-layout-line-solid' },
  { name: 'ti-layout-grid4' },
  { name: 'ti-layout-grid3' },
  { name: 'ti-layout-grid2' },
  { name: 'ti-layout-grid2-thumb' },
  { name: 'ti-layout-cta-right' },
  { name: 'ti-layout-cta-left' },
  { name: 'ti-layout-cta-center' },
  { name: 'ti-layout-cta-btn-right' },
  { name: 'ti-layout-cta-btn-left' },
  { name: 'ti-layout-column4' },
  { name: 'ti-layout-column3' },
  { name: 'ti-layout-column2' },
  { name: 'ti-layout-column2' },
  { name: 'ti-layout-accordion-merged' },
  { name: 'ti-layout-accordion-list' },
  { name: 'ti-widgetized' },
  { name: 'ti-widget' },
  { name: 'ti-widget-alt' },
  { name: 'ti-view-list' },
  { name: 'ti-view-list-alt' },
  { name: 'ti-view-grid' },
  { name: 'ti-upload' },
  { name: 'ti-download' },
  { name: 'ti-loop' },
  { name: 'ti-layout-sidebar-2' },
  { name: 'ti-layout-grid4-alt' },
  { name: 'ti-layout-grid3-alt' },
  { name: 'ti-layout-grid2-alt' },
  { name: 'ti-layout-column4-alt' },
  { name: 'ti-layout-column3-alt' },
  { name: 'ti-layout-column2-alt' },
  { name: 'ti-flickr' },
  { name: 'ti-flickr-alt' },
  { name: 'ti-instagram' },
  { name: 'ti-google' },
  { name: 'ti-github' },
  { name: 'ti-facebook' },
  { name: 'ti-dropbox' },
  { name: 'ti-dropbox-alt' },
  { name: 'ti-dribbble' },
  { name: 'ti-apple' },
  { name: 'ti-android' },
  { name: 'ti-yahoo' },
  { name: 'ti-trello' },
  { name: 'ti-stack-overflow' },
  { name: 'ti-soundcloud' },
  { name: 'ti-sharethis' },
  { name: 'ti-sharethis-alt' },
  { name: 'ti-reddit' },
  { name: 'ti-microsoft' },
  { name: 'ti-microsoft-alt' },
  { name: 'ti-linux' },
  { name: 'ti-jsfiddle' },
  { name: 'ti-joomla' },
  { name: 'ti-html5' },
  { name: 'ti-css3' },
  { name: 'ti-drupal' },
  { name: 'ti-wordpress' },
  { name: 'ti-tumblr' },
  { name: 'ti-tumblr-alt' },
  { name: 'ti-skype' },
  { name: 'ti-youtube' },
  { name: 'ti-vimeo' },
  { name: 'ti-vimeo-alt' },
  { name: 'ti-twitter' },
  { name: 'ti-twitter-alt' },
  { name: 'ti-linkedin' },
  { name: 'ti-pinterest' },
  { name: 'ti-pinterest-alt' },
];
export const USERTYPE = {
  admin: {
    id: 'fcd33a3a-6925-40f9-9361-750a39709988',
    name: 'Administrador'
  },
  analistaCredito: {
    id: 'f3a86f9a-2ea2-45ed-a669-e4c6f79ba9f4',
    name: 'Analista de Crédito'
  },
  atendimentoCliente: {
    id: 'f27b6623-6155-4945-8089-46b4aa61caea',
    name: 'Atendimento ao Cliente'
  },
  controllerMaster: {
    id: '64cea7eb-9eae-4228-8209-0fe5fe3e71d7',
    name: 'Controller Master'
  }
};

export const MOVEMENTTYPE = {
  auditoria: {
    id: 'b5d5450d-f3fe-4d98-a3d6-6da8f7726b50',
    title: 'Auditoria'
  },
  devolucao: {
    id: 'ef34dd46-580d-4776-b998-a8d8702adf53',
    title: 'Devolução'
  },
  devolucaoEntrega: {
    id: 'd03358ca-7570-4a1b-b5c7-5e4ffc1acd47',
    title: 'Devolução Entrega'
  },
  entrega: {
    id: '75bc2265-9505-4939-818b-6415b877a7d4',
    title: 'Entrega'
  },
  entregaParcial: {
    id: 'fc60a56c-26f8-47f2-b144-5481250f31be',
    title: 'Entrega Parcial'
  },
  regresso: {
    id: '5825ea34-a333-4822-9a0d-e8f5594b0a11',
    title: 'Regresso'
  },
  retirada: {
    id: '801b2de6-c6e4-4cab-b745-74610178e782',
    title: 'Retirada'
  },
  retorno: {
    id: '3acc6616-2993-4609-bf16-972db0e8a89b',
    title: 'Retorno'
  },
  remessa: {
    id: '449f5918-edc1-4f16-a36a-ce65ec891fcf',
    title: 'Remessa'
  },
  transferencia: {
    id: '71f2436a-183b-4e31-a0db-e3dc80b32de2',
    title: 'Transferência'
  },
  transferenciaEstado: {
    id: 'cf9ab2cd-786a-4fbb-b829-02571ed53298',
    title: 'Transferência Estado da RTI '
  }
};

export const MOVEMENTTYPEFILTER = {
  auditoria: {
    id: 'b5d5450d-f3fe-4d98-a3d6-6da8f7726b50',
    title: 'Auditoria'
  },
  devolucao: {
    id: 'ef34dd46-580d-4776-b998-a8d8702adf53',
    title: 'Devolução'
  },
  devolucaoEntrega: {
    id: 'd03358ca-7570-4a1b-b5c7-5e4ffc1acd47',
    title: 'Devolução Entrega'
  },
  entrega: {
    id: '75bc2265-9505-4939-818b-6415b877a7d4',
    title: 'Entrega'
  },
  regresso: {
    id: '5825ea34-a333-4822-9a0d-e8f5594b0a11',
    title: 'Regresso'
  },
  retirada: {
    id: '801b2de6-c6e4-4cab-b745-74610178e782',
    title: 'Retirada'
  },
  retorno: {
    id: '3acc6616-2993-4609-bf16-972db0e8a89b',
    title: 'Retorno'
  },
  remessa: {
    id: '449f5918-edc1-4f16-a36a-ce65ec891fcf',
    title: 'Remessa'
  },
  transferencia: {
    id: '71f2436a-183b-4e31-a0db-e3dc80b32de2',
    title: 'Transferência'
  },
  transferenciaEstado: {
    id: 'cf9ab2cd-786a-4fbb-b829-02571ed53298',
    title: 'Transferência Estado da RTI '
  }
};

export const MOVEMENTSTEP = {
  agendamento: {
    id: '4248fbde-b052-4c25-8f6c-9f827a1453bd',
    title: 'Agendamento'
  },
  autorizacao: {
    id: '35acff31-1e2e-42ad-bd34-83c994d1c305',
    title: 'Autorização'
  },
  agendamentoRetorno: {
    id: '56beba3c-f482-4826-b3d9-a8af85acf2f7',
    title: 'Agendamento Retornos'
  },
  validacao: {
    id: '6e6554d4-6e32-4647-bc14-c51fb0f960d5',
    title: 'Validação'
  },
  preparacaoCarga: {
    id: '0444ac78-0b6c-4356-84a9-f1586811bcd2',
    title: 'Preparação de Carga'
  },
  transito: {
    id: '3f248c24-25dc-49ee-8fde-e6c3a48188eb',
    title: 'Trânsito'
  },
  registro: {
    id: '8fd66e5e-8c36-4c9f-83f5-0d66f4a96e09',
    title: 'Registro'
  },
  concluido: {
    id: '65d256b5-c732-4bb6-9153-81e0edacae16',
    title: 'Concluído'
  },
};

export const MOVEMENTSTEPFILTER = {
  agendamento: {
    id: '4248fbde-b052-4c25-8f6c-9f827a1453bd',
    title: 'Agendamento'
  },
  autorizacao: {
    id: '35acff31-1e2e-42ad-bd34-83c994d1c305',
    title: 'Autorização'
  },
  validacao: {
    id: '6e6554d4-6e32-4647-bc14-c51fb0f960d5',
    title: 'Validação'
  },
  preparacaoCarga: {
    id: '0444ac78-0b6c-4356-84a9-f1586811bcd2',
    title: 'Preparação de Carga'
  },
  transito: {
    id: '3f248c24-25dc-49ee-8fde-e6c3a48188eb',
    title: 'Trânsito'
  },
  registro: {
    id: '8fd66e5e-8c36-4c9f-83f5-0d66f4a96e09',
    title: 'Registro'
  },
  concluido: {
    id: '65d256b5-c732-4bb6-9153-81e0edacae16',
    title: 'Concluído'
  },
};

export const RTISTATUS = {
  nova: {
    id: 'dee33de9-616e-42db-87c6-34412196e53f',
    title: 'nova'
  },
  avariada: {
    id: 'ad20f5a0-9c4d-4d7b-b7ba-5f36c3716ea7',
    title: 'Avariada'
  },
  limpa: {
    id: '94ecad2c-dedc-4e49-94a1-96022933005a',
    title: 'Limpa'
  },
  produto: {
    id: '8137f850-d41e-4b71-9d7c-0db1c8cc3589',
    title: 'Produto'
  },
  suja: {
    id: '150c43f8-2638-4b3f-a438-f89339c6c235',
    title: 'Suja'
  },
  em_transito: {
    id: 'fb8984bb-3c68-4568-a35e-148eebb66c59',
    title: 'Em Trânsito'
  }
};

export const RTITYPE = {
  hb415: {
    id: 'b8728537-2475-4632-9da8-95a14414e93d',
    title: 'HB 415',
    isPallet: false
  },
  hb612: {
    id: '590829d7-4cdb-4c97-942c-55a2a78ae334',
    title: 'HB 612',
    isPallet: false
  },
  hb618: {
    id: '3a1e2c36-6213-4c34-a52b-88b8fa4af2be',
    title: 'HB 618',
    isPallet: false
  },
  hb623: {
    id: '63c0769f-4c53-4ca8-8de6-49644cd1396e',
    title: 'HB 623',
    isPallet: false
  },
  hb6332: {
    id: '98be9644-fc51-4af2-9e85-387949f4a8ec',
    title: 'HB 6332',
    isPallet: false
  },
  hbBIN750: {
    id: '66c42418-3b30-44f0-bfef-30d3675230bd',
    title: 'HB BIN 750',
    isPallet: false
  },
  hbCAIXAPRODUTOR: {
    id: '7d6ce7a3-71df-4fcb-bf08-1d6ba895cd8e',
    title: 'HB CAIXA PRODUTOR',
    isPallet: false
  },
  hbPLTPBR: {
    id: '2fd25da8-88ee-4b78-98b9-1aa5ecd7a491',
    title: 'HB PLT PBR',
    isPallet: true
  },
  hbPLTPLASTICO: {
    id: 'b6bf8534-d7c5-4330-bfd7-35de0fd2ffcc',
    title: 'HB PLT PLÁSTICO',
    isPallet: true
  }
}

export const PLACETYPE = {
  hb: {
    id: '464cfbde-ffd3-47cf-9a08-0c086763af4a',
    title: 'HB'
  },
  loja: {
    id: '4ddf2739-2b42-4b3c-abb9-b03f5c5be5d8',
    title: 'Loja'
  },
  produtor: {
    id: 'ff5d78a7-91ce-4d3d-a777-8f989df827f6',
    title: 'Produtor'
  },
  varejista: {
    id: '1f411bb0-fa6a-47be-a836-45c1204f4b7c',
    title: 'Varejista'
  },
  auditoria: {
    id: 'd67108fe-7cc7-4480-abed-1bc7f67c8022',
    title: 'Auditoria'
  }
};


export const PAYMENTSTATUS = {
  pago_parcialmente: {
    id: '6eebb2ae-8c8d-4901-b146-0d899fd6a8d9',
    title: 'Pago Parcialmente'
  },
  emAtraso: {
    id: '76312a26-2e38-4318-a47e-9d716253091b',
    title: 'em Atraso'
  },
  pago: {
    id: '31c6f454-ef96-4944-a268-0ada02cd3024',
    title: 'Pago'
  },
  pendente: {
    id: '520c8584-7bb5-4db6-bdb5-e7e467a1a72e',
    title: 'Pendente'
  },
  cancelado: {
    id: '3e72e8b0-0c41-4e9e-a3fa-4e0e06318761',
    title: 'Cancelado'
  }
};

export const DOCUMENTTYPE = {
  CPF: {
    id: 'edc74798-792b-4cab-9c48-4943f0f4bfc3',
    title: 'CPF',
    mask: '000.000.000-00'
  },
  CNPJ: {
    id: 'd13ba862-2297-445b-a966-23133b05856a',
    title: 'CNPJ',
    mask: '00.000.000/0000-00'
  },
};
export const VALUESTEPMOVEMENT = {
  NEGADO: {
    value: 3,
    msg: 'Existe Tarefa pendente',
  },
  NEUTRO: {
    value: 0,
    msg: 'Ainda não foi realizado as tarefas',
  },
  APROVADO: {
    value: 2,
    msg: 'Tarefas realizadas',
  },
  EMPROGRESSO: {
    value: 1,
    msg: 'Realiando',
  },
};
export const MOVEMENTFILTERNEXTSTEP = {
  NEGADO: {
    value: 3,
  },
  APROVADO: {
    value: 2,
  },
  CONCLUIDO: {
    value: 1,
  },
};
export const MOVEMENTPERMISSIONSTEP = {
  BLOQUEADO: {
    value: 'hide',
  },
  VISUALIZAR: {
    value: 'view',
  },
  EDITAVEL: {
    value: 'edit',
  },
};
export const REVENUESTATUS = {
  CALCULADO: {
    id: '9e211d16-5c9c-4960-987a-3f4837f0d2ad',
    name: 'Calculado',
  },
  PENDENTE: {
    id: '9e2c2c17-7167-46fa-a0a4-f9e24c91ef20',
    name: 'Pendente',
  },
  GERADO: {
    id: 'ae0bbbcf-a576-4528-b628-9fe3bdb6e473',
    name: 'Gerado',
  },
  CANCELADO: {
    id: 'bacbba22-4dd7-46f1-a76a-382a7e115072',
    name: 'Cancelado',
  },
  CONFERIDO: {
    id: 'c32fad47-03bb-46f2-b888-3de95dfdad6e',
    name: 'Conferido',
  },
  FATURADO: {
    id: 'c7d79e81-84e3-4f77-a378-c8788d9c2158',
    name: 'Faturado',
  },
  CONFIRMADO: {
    id: 'd99d251b-be03-46e1-8959-de3ca4c19757',
    name: 'Confirmado',
  },
};
export const CASHFLOW = [
  {
    id: '4bbc57d1-a39e-42ae-b4ab-7af517ff2855',
    name: 'Conta Contas a Pagar',
  },
  {
    id: '4e0e194b-ef27-4a40-aecb-8b083ee0e6eb',
    name: 'Conta Faturamento',
  },
  {
    id: 'f27ecd11-2088-499d-81e6-13505d216a96',
    name: 'Conta Contas a Receber',
  }
];
export const TYPEDATESELECT = [
  {
    id: '0',
    name: 'Emissão',
    order: 'release_date'
  },
  {
    id: '1',
    name: 'Vencimento',
    order: 'due_date'
  },
  {
    id: '2',
    name: 'Liquidação',
    order: 'billing_date'
  }
];
export const TYPEBUYERSELECT = [
  {
    id: '0',
    name: 'Nome Fantasia'
  },
  {
    id: '1',
    name: 'Razão Social'
  }
];
export const STATUSPAYMENTFORINTSTALMENTS = [
  {
    id: '31c6f454-ef96-4944-a268-0ada02cd3024',
    name: 'Pago',
  },
  {
    id: '6eebb2ae-8c8d-4901-b146-0d899fd6a8d9',
    name: 'Pago Parcialmente',
  },
  {
    id: '520c8584-7bb5-4db6-bdb5-e7e467a1a72e',
    name: 'Pendente',
  }
];
export const STATUSCONCILIATION = [
  {
    id: 0,
    name: 'Não gerado',
  },
  {
    id: 1,
    name: 'Gerado',
  },
  {
    id: 2,
    name: 'Registrado no Banco',
  },
  {
    id: 3,
    name: 'Conciliado',
  },
  {
    id: 4,
    name: 'Divergência',
  }
];

export const CFOP = [
  {
    code: 5551,
    description: "Venda de bem do ativo imobilizado"
  },
  {
    code: 5901,
    description: "Remessa p\/ industrialização por encomenda"
  },
  {
    code: 5905,
    description: "Remessa p\/ depósito fechado ou armazém geral"
  },
  {
    code: 5920,
    description: "Remessa de vasilhame ou sacaria"
  },
  {
    code: 5949,
    description: "Outra saída de mercadoria ou prestação de serviço não especificado"
  },
  {
    code: 6552,
    description: "Transferência de bem do ativo imobilizado"
  },
  {
    code: 6905,
    description: "Remessa p\/ depósito fechado ou armazém geral"
  },
  {
    code: 6920,
    description: 'Remessa de vasilhame ou sacaria',
  },
  {
    code: 6949,
    description: 'Outra saída de mercadoria ou prestação de serviço não especificado',
  },
  {
    code: 1201,
    description: "Devolução de venda de produção do estabelecimento "
  },
  {
    code: 1202,
    description: "Devolução de venda de mercadoria adquirida ou recebida de terceiros"
  },
  {
    code: 1206,
    description: "Anulação de valor relativo à prestação de serviço de transporte"
  },
  {
    code: 1208,
    description: "Devolução de produção do estabelecimento, remetida em transferência"
  },
  {
    code: 1209,
    description: "Devolução de mercadoria adquirida ou recebida de terceiros, remetida em transferência"
  },
  {
    code: 1212,
    description: "Devolução de venda no mercado interno de mercadoria industrializada e insumo importado sob o Regime Aduaneiro Especial de Entreposto Industrial (Recof-Sped)"
  },
  {
    code: 1401,
    description: "Compra p\/ industrialização ou produção rural de mercadoria sujeita a ST"
  },
  {
    code: 1403,
    description: "Compra p\/ comercialização em operação com mercadoria sujeita a ST"
  },
  {
    code: 1406,
    description: "Compra de bem p\/ o ativo imobilizado cuja mercadoria está sujeita a ST"
  },
  {
    code: 1407,
    description: "Compra de mercadoria p\/ uso ou consumo cuja mercadoria está sujeita a ST"
  },
  {
    code: 1408,
    description: "Transferência p\/ industrialização ou produção rural de mercadoria sujeita a ST"
  },
  {
    code: 1409,
    description: "Transferência p\/ comercialização em operação com mercadoria sujeita a ST"
  },
  {
    code: 1410,
    description: "Devolução de venda de mercadoria, de produção do estabelecimento, sujeita a ST"
  },
  {
    code: 1411,
    description: "Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita a ST"
  },
  {
    code: 1414,
    description: "Retorno de mercadoria de produção do estabelecimento, remetida p\/ venda fora do estabelecimento, sujeita a ST"
  },
  {
    code: 1415,
    description: "Retorno de mercadoria adquirida ou recebida de terceiros, remetida p\/ venda fora do estabelecimento em operação com mercadoria sujeita a ST"
  },
  {
    code: 1452,
    description: "Retorno de insumo não utilizado na produção"
  },
  {
    code: 1501,
    description: "Entrada de mercadoria recebida com fim específico de exportação"
  },
  {
    code: 1503,
    description: "Entrada decorrente de devolução de produto, de fabricação do estabelecimento, remetido com fim específico de exportação"
  },
  {
    code: 1504,
    description: "Entrada decorrente de devolução de mercadoria remetida com fim específico de exportação, adquirida ou recebida de terceiros"
  },
  {
    code: 1505,
    description: "Entrada decorrente de devolução simbólica de mercadoria remetida p\/ formação de lote de exportação, de produto industrializado ou produzido pelo próprio estabelecimento."
  },
  {
    code: 1506,
    description: "Entrada decorrente de devolução simbólica de mercadoria, adquirida ou recebida de terceiros, remetida p\/ formação de lote de exportação."
  },
  {
    code: 1551,
    description: "Compra de bem p\/ o ativo imobilizado"
  },
  {
    code: 1552,
    description: "Transferência de bem do ativo imobilizado"
  },
  {
    code: 1553,
    description: "Devolução de venda de bem do ativo imobilizado"
  },
  {
    code: 1554,
    description: "Retorno de bem do ativo imobilizado remetido p\/ uso fora do estabelecimento"
  },
  {
    code: 1555,
    description: "Entrada de bem do ativo imobilizado de terceiro, remetido p\/ uso no estabelecimento"
  },
  {
    code: 1556,
    description: "Compra de material p\/ uso ou consumo"
  },
  {
    code: 1557,
    description: "Transferência de material p\/ uso ou consumo"
  },
  {
    code: 1601,
    description: "Recebimento, por transferência, de crédito de ICMS"
  },
  {
    code: 1602,
    description: "Recebimento, por transferência, de saldo credor do ICMS, de outro estabelecimento da mesma empresa, p\/ compensação de saldo devedor do imposto. "
  },
  {
    code: 1603,
    description: "Ressarcimento de ICMS retido por substituição tributária"
  },
  {
    code: 1605,
    description: "Recebimento, por transferência, de saldo devedor do ICMS de outro estabelecimento da mesma empresa"
  },
  {
    code: 1901,
    description: "Entrada p\/ industrialização por encomenda"
  },
  {
    code: 1902,
    description: "Retorno de mercadoria remetida p\/ industrialização por encomenda"
  },
  {
    code: 1903,
    description: "Entrada de mercadoria remetida p\/ industrialização e não aplicada no referido processo"
  },
  {
    code: 1904,
    description: "Retorno de remessa p\/ venda fora do estabelecimento"
  },
  {
    code: 1905,
    description: "Entrada de mercadoria recebida p\/ depósito em depósito fechado ou armazém geral"
  },
  {
    code: 1906,
    description: "Retorno de mercadoria remetida p\/ depósito fechado ou armazém geral"
  },
  {
    code: 1907,
    description: "Retorno simbólico de mercadoria remetida p\/ depósito fechado ou armazém geral"
  },
  {
    code: 1908,
    description: "Entrada de bem por conta de contrato de comodato"
  },
  {
    code: 1909,
    description: "Retorno de bem remetido por conta de contrato de comodato"
  },
  {
    code: 1910,
    description: "Entrada de bonificação, doação ou brinde"
  },
  {
    code: 1911,
    description: "Entrada de amostra grátis"
  },
  {
    code: 1912,
    description: "Entrada de mercadoria ou bem recebido p\/ demonstração"
  },
  {
    code: 1913,
    description: "Retorno de mercadoria ou bem remetido p\/ demonstração"
  },
  {
    code: 1914,
    description: "Retorno de mercadoria ou bem remetido p\/ exposição ou feira"
  },
  {
    code: 1915,
    description: "Entrada de mercadoria ou bem recebido p\/ conserto ou reparo"
  },
  {
    code: 1916,
    description: "Retorno de mercadoria ou bem remetido p\/ conserto ou reparo"
  },
  {
    code: 1917,
    description: "Entrada de mercadoria recebida em consignação mercantil ou industrial"
  },
  {
    code: 1918,
    description: "Devolução de mercadoria remetida em consignação mercantil ou industrial"
  },
  {
    code: 1919,
    description: "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, remetida anteriormente em consignação mercantil ou industrial"
  },
  {
    code: 1920,
    description: "Entrada de vasilhame ou sacaria"
  },
  {
    code: 1921,
    description: "Retorno de vasilhame ou sacaria"
  },
  {
    code: 1923,
    description: "Entrada de mercadoria recebida do vendedor remetente, em venda à ordem"
  },
  {
    code: 1924,
    description: "Entrada p\/ industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    code: 1925,
    description: "Retorno de mercadoria remetida p\/ industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    code: 1933,
    description: "Aquisição de serviço tributado pelo Imposto sobre Serviços de Qualquer Natureza"
  },
  {
    code: 1934,
    description: "Entrada simbólica de mercadoria recebida p\/ depósito fechado ou armazém geral"
  },
  {
    code: 1949,
    description: "Outra entrada de mercadoria ou prestação de serviço não especificada"
  },
  {
    code: 2101,
    description: "Compra p\/ industrialização ou produção rural"
  },
  {
    code: 2102,
    description: "Compra p\/ comercialização"
  },
  {
    code: 2111,
    description: "Compra p\/ industrialização de mercadoria recebida anteriormente em consignação industrial"
  },
  {
    code: 2113,
    description: "Compra p\/ comercialização, de mercadoria recebida anteriormente em consignação mercantil"
  },
  {
    code: 2116,
    description: "Compra p\/ industrialização ou produção rural originada de encomenda p\/ recebimento futuro"
  },
  {
    code: 2117,
    description: "Compra p\/ comercialização originada de encomenda p\/ recebimento futuro"
  },
  {
    code: 2118,
    description: "Compra de mercadoria p\/ comercialização pelo adquirente originário, entregue pelo vendedor remetente ao destinatário, em venda à ordem"
  },
  {
    code: 2120,
    description: "Compra p\/ industrialização, em venda à ordem, já recebida do vendedor remetente"
  },
  {
    code: 2121,
    description: "Compra p\/ comercialização, em venda à ordem, já recebida do vendedor remetente"
  },
  {
    code: 2122,
    description: "Compra p\/ industrialização em que a mercadoria foi remetida pelo fornecedor ao industrializador sem transitar pelo estabelecimento adquirente"
  },
  {
    code: 2126,
    description: "Compra p\/ utilização na prestação de serviço sujeita ao ICMS"
  },
  {
    code: 2128,
    description: "Compra p\/ utilização na prestação de serviço sujeita ao ISSQN"
  },
  {
    code: 2151,
    description: "Transferência p\/ industrialização ou produção rural"
  },
  {
    code: 2152,
    description: "Transferência p\/ comercialização"
  },
  {
    code: 2154,
    description: "Transferência p\/ utilização na prestação de serviço"
  },
  {
    code: 2201,
    description: "Devolução de venda de produção do estabelecimento"
  },
  {
    code: 2202,
    description: "Devolução de venda de mercadoria adquirida ou recebida de terceiros"
  },
  {
    code: 2206,
    description: "Anulação de valor relativo à prestação de serviço de transporte"
  },
  {
    code: 2208,
    description: "Devolução de produção do estabelecimento, remetida em transferência."
  },
  {
    code: 2209,
    description: "Devolução de mercadoria adquirida ou recebida de terceiros e remetida em transferência"
  },
  {
    code: 2212,
    description: "Devolução de venda no mercado interno de mercadoria industrializada e insumo importado sob o Regime Aduaneiro Especial de Entreposto Industrial (Recof-Sped)"
  },
  {
    code: 2401,
    description: "Compra p\/ industrialização ou produção rural de mercadoria sujeita a ST"
  },
  {
    code: 2403,
    description: "Compra p\/ comercialização em operação com mercadoria sujeita a ST"
  },
  {
    code: 2406,
    description: "Compra de bem p\/ o ativo imobilizado cuja mercadoria está sujeita a ST"
  },
  {
    code: 2407,
    description: "Compra de mercadoria p\/ uso ou consumo cuja mercadoria está sujeita a ST"
  },
  {
    code: 2408,
    description: "Transferência p\/ industrialização ou produção rural de mercadoria sujeita a ST"
  },
  {
    code: 2409,
    description: "Transferência p\/ comercialização em operação com mercadoria sujeita a ST"
  },
  {
    code: 2410,
    description: "Devolução de venda de produção do estabelecimento, quando o produto sujeito a ST"
  },
  {
    code: 2411,
    description: "Devolução de venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita a ST"
  },
  {
    code: 2414,
    description: "Retorno de produção do estabelecimento, remetida p\/ venda fora do estabelecimento, quando o produto sujeito a ST"
  },
  {
    code: 2415,
    description: "Retorno de mercadoria adquirida ou recebida de terceiros, remetida p\/ venda fora do estabelecimento em operação com mercadoria sujeita a ST"
  },
  {
    code: 2501,
    description: "Entrada de mercadoria recebida com fim específico de exportação"
  },
  {
    code: 2503,
    description: "Entrada decorrente de devolução de produto industrializado pelo estabelecimento, remetido com fim específico de exportação"
  },
  {
    code: 2504,
    description: "Entrada decorrente de devolução de mercadoria remetida com fim específico de exportação, adquirida ou recebida de terceiros"
  },
  {
    code: 2505,
    description: "Entrada decorrente de devolução simbólica de mercadoria remetida p\/ formação de lote de exportação, de produto industrializado ou produzido pelo próprio estabelecimento."
  },
  {
    code: 2506,
    description: "Entrada decorrente de devolução simbólica de mercadoria, adquirida ou recebida de terceiros, remetida p\/ formação de lote de exportação."
  },
  {
    code: 2551,
    description: "Compra de bem p\/ o ativo imobilizado"
  },
  {
    code: 2552,
    description: "Transferência de bem do ativo imobilizado"
  },
  {
    code: 2553,
    description: "Devolução de venda de bem do ativo imobilizado"
  },
  {
    code: 2554,
    description: "Retorno de bem do ativo imobilizado remetido p\/ uso fora do estabelecimento"
  },
  {
    code: 2555,
    description: "Entrada de bem do ativo imobilizado de terceiro, remetido p\/ uso no estabelecimento"
  },
  {
    code: 2556,
    description: "Compra de material p\/ uso ou consumo"
  },
  {
    code: 2557,
    description: "Transferência de material p\/ uso ou consumo"
  },
  {
    code: 2603,
    description: "Ressarcimento de ICMS retido por substituição tributária"
  },
  {
    code: 2901,
    description: "Entrada p\/ industrialização por encomenda"
  },
  {
    code: 2902,
    description: "Retorno de mercadoria remetida p\/ industrialização por encomenda"
  },
  {
    code: 2903,
    description: "Entrada de mercadoria remetida p\/ industrialização e não aplicada no referido processo"
  },
  {
    code: 2904,
    description: "Retorno de remessa p\/ venda fora do estabelecimento"
  },
  {
    code: 2905,
    description: "Entrada de mercadoria recebida p\/ depósito em depósito fechado ou armazém geral"
  },
  {
    code: 2906,
    description: "Retorno de mercadoria remetida p\/ depósito fechado ou armazém geral"
  },
  {
    code: 2907,
    description: "Retorno simbólico de mercadoria remetida p\/ depósito fechado ou armazém geral"
  },
  {
    code: 2908,
    description: "Entrada de bem por conta de contrato de comodato"
  },
  {
    code: 2909,
    description: "Retorno de bem remetido por conta de contrato de comodato"
  },
  {
    code: 2910,
    description: "Entrada de bonificação, doação ou brinde"
  },
  {
    code: 2911,
    description: "Entrada de amostra grátis"
  },
  {
    code: 2912,
    description: "Entrada de mercadoria ou bem recebido p\/ demonstração"
  },
  {
    code: 2913,
    description: "Retorno de mercadoria ou bem remetido p\/ demonstração"
  },
  {
    code: 2914,
    description: "Retorno de mercadoria ou bem remetido p\/ exposição ou feira"
  },
  {
    code: 2915,
    description: "Entrada de mercadoria ou bem recebido p\/ conserto ou reparo"
  },
  {
    code: 2916,
    description: "Retorno de mercadoria ou bem remetido p\/ conserto ou reparo"
  },
  {
    code: 2917,
    description: "Entrada de mercadoria recebida em consignação mercantil ou industrial"
  },
  {
    code: 2918,
    description: "Devolução de mercadoria remetida em consignação mercantil ou industrial"
  },
  {
    code: 2919,
    description: "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, remetida anteriormente em consignação mercantil ou industrial"
  },
  {
    code: 2920,
    description: "Entrada de vasilhame ou sacaria"
  },
  {
    code: 2921,
    description: "Retorno de vasilhame ou sacaria"
  },
  {
    code: 2923,
    description: "Entrada de mercadoria recebida do vendedor remetente, em venda à ordem"
  },
  {
    code: 2924,
    description: "Entrada p\/ industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    code: 2925,
    description: "Retorno de mercadoria remetida p\/ industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    code: 2933,
    description: "Aquisição de serviço tributado pelo Imposto Sobre Serviços de Qualquer Natureza"
  },
  {
    code: 2934,
    description: "Entrada simbólica de mercadoria recebida p\/ depósito fechado ou armazém geral"
  },
  {
    code: 2949,
    description: "Outra entrada de mercadoria ou prestação de serviço não especificado"
  },
  {
    code: 5101,
    description: "Venda de produção do estabelecimento"
  },
  {
    code: 5102,
    description: "Venda de mercadoria adquirida ou recebida de terceiros"
  },
  {
    code: 5103,
    description: "Venda de produção do estabelecimento efetuada fora do estabelecimento"
  },
  {
    code: 5104,
    description: "Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento"
  },
  {
    code: 5105,
    description: "Venda de produção do estabelecimento que não deva por ele transitar"
  },
  {
    code: 5106,
    description: "Venda de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar "
  },
  {
    code: 5111,
    description: "Venda de produção do estabelecimento remetida anteriormente em consignação industrial"
  },
  {
    code: 5112,
    description: "Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação industrial"
  },
  {
    code: 5113,
    description: "Venda de produção do estabelecimento remetida anteriormente em consignação mercantil"
  },
  {
    code: 5114,
    description: "Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil"
  },
  {
    code: 5115,
    description: "Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil"
  },
  {
    code: 5116,
    description: "Venda de produção do estabelecimento originada de encomenda p\/ entrega futura"
  },
  {
    code: 5117,
    description: "Venda de mercadoria adquirida ou recebida de terceiros, originada de encomenda p\/ entrega futura"
  },
  {
    code: 5118,
    description: "Venda de produção do estabelecimento entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem"
  },
  {
    code: 5119,
    description: "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem"
  },
  {
    code: 5120,
    description: "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário pelo vendedor remetente, em venda à ordem"
  },
  {
    code: 5122,
    description: "Venda de produção do estabelecimento remetida p\/ industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente"
  },
  {
    code: 5123,
    description: "Venda de mercadoria adquirida ou recebida de terceiros remetida p\/ industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente"
  },
  {
    code: 5129,
    description: "Venda de insumo importado e de mercadoria industrializada sob o amparo do Regime Aduaneiro Especial de Entreposto Industrial (Recof-Sped)"
  },
  {
    code: 5151
  },
  {
    code: 5152,
    description: "Transferência de mercadoria adquirida ou recebida de terceiros"
  },
  {
    code: 5155,
    description: "Transferência de produção do estabelecimento, que não deva por ele transitar"
  },
  {
    code: 5156,
    description: "Transferência de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar"
  },
  {
    code: 5201,
    description: "Devolução de compra p\/ industrialização ou produção rural"
  },
  {
    code: 5202,
    description: "Devolução de compra p\/ comercialização"
  },
  {
    code: 5206,
    description: "Anulação de valor relativo a aquisição de serviço de transporte"
  },
  {
    code: 5208,
    description: "Devolução de mercadoria recebida em transferência p\/ industrialização ou produção rural "
  },
  {
    code: 5209,
    description: "Devolução de mercadoria recebida em transferência p\/ comercialização"
  },
  {
    code: 5210,
    description: "Devolução de compra p\/ utilização na prestação de serviço"
  },
  {
    code: 5401,
    description: "Venda de produção do estabelecimento quando o produto esteja sujeito a ST"
  },
  {
    code: 5402,
    description: "Venda de produção do estabelecimento de produto sujeito a ST, em operação entre contribuintes substitutos do mesmo produto"
  },
  {
    code: 5403,
    description: "Venda de mercadoria, adquirida ou recebida de terceiros, sujeita a ST, na condição de contribuinte-substituto"
  },
  {
    code: 5405,
    description: "Venda de mercadoria, adquirida ou recebida de terceiros, sujeita a ST, na condição de contribuinte-substituído"
  },
  {
    code: 5408,
    description: "Transferência de produção do estabelecimento quando o produto sujeito a ST"
  },
  {
    code: 5409,
    description: "Transferência de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita a ST"
  },
  {
    code: 5410,
    description: "Devolução de compra p\/ industrialização de mercadoria sujeita a ST"
  },
  {
    code: 5411,
    description: "Devolução de compra p\/ comercialização em operação com mercadoria sujeita a ST"
  },
  {
    code: 5412,
    description: "Devolução de bem do ativo imobilizado, em operação com mercadoria sujeita a ST"
  },
  {
    code: 5413,
    description: "Devolução de mercadoria destinada ao uso ou consumo, em operação com mercadoria sujeita a ST."
  },
  {
    code: 5414,
    description: "Remessa de produção do estabelecimento p\/ venda fora do estabelecimento, quando o produto sujeito a ST"
  },
  {
    code: 5415,
    description: "Remessa de mercadoria adquirida ou recebida de terceiros p\/ venda fora do estabelecimento, em operação com mercadoria sujeita a ST"
  },
  {
    code: 5501,
    description: "Remessa de produção do estabelecimento, com fim específico de exportação"
  },
  {
    code: 5502,
    description: "Remessa de mercadoria adquirida ou recebida de terceiros, com fim específico de exportação"
  },
  {
    code: 5503,
    description: "Devolução de mercadoria recebida com fim específico de exportação"
  },
  {
    code: 5504,
    description: "Remessa de mercadoria p\/ formação de lote de exportação, de produto industrializado ou produzido pelo próprio estabelecimento."
  },
  {
    code: 5505,
    description: "Remessa de mercadoria, adquirida ou recebida de terceiros, p\/ formação de lote de exportação."
  },
  {
    code: 5552,
    description: "Transferência de bem do ativo imobilizado"
  },
  {
    code: 5553,
    description: "Devolução de compra de bem p\/ o ativo imobilizado"
  },
  {
    code: 5554,
    description: "Remessa de bem do ativo imobilizado p\/ uso fora do estabelecimento"
  },
  {
    code: 5555,
    description: "Devolução de bem do ativo imobilizado de terceiro, recebido p\/ uso no estabelecimento"
  },
  {
    code: 5556,
    description: "Devolução de compra de material de uso ou consumo"
  },
  {
    code: 5557,
    description: "Transferência de material de uso ou consumo"
  },
  {
    code: 5601,
    description: "Transferência de crédito de ICMS acumulado"
  },
  {
    code: 5602,
    description: "Transferência de saldo credor do ICMS, p\/ outro estabelecimento da mesma empresa, destinado à compensação de saldo devedor do ICMS"
  },
  {
    code: 5603,
    description: "Ressarcimento de ICMS retido por substituição tributária"
  },
  {
    code: 5605,
    description: "Transferência de saldo devedor do ICMS de outro estabelecimento da mesma empresa  "
  },
  {
    code: 5606,
    description: "Utilização de saldo credor do ICMS p\/ extinção por compensação de débitos fiscais"
  },
  {
    code: 5902,
    description: "Retorno de mercadoria utilizada na industrialização por encomenda"
  },
  {
    code: 5903,
    description: "Retorno de mercadoria recebida p\/ industrialização e não aplicada no referido processo"
  },
  {
    code: 5904,
    description: "Remessa p\/ venda fora do estabelecimento"
  },
  {
    code: 5906,
    description: "Retorno de mercadoria depositada em depósito fechado ou armazém geral"
  },
  {
    code: 5907,
    description: "Retorno simbólico de mercadoria depositada em depósito fechado ou armazém geral"
  },
  {
    code: 5908,
    description: "Remessa de bem por conta de contrato de comodato"
  },
  {
    code: 5909,
    description: "Retorno de bem recebido por conta de contrato de comodato"
  },
  {
    code: 5910,
    description: "Remessa em bonificação, doação ou brinde"
  },
  {
    code: 5911,
    description: "Remessa de amostra grátis"
  },
  {
    code: 5912,
    description: "Remessa de mercadoria ou bem p\/ demonstração"
  },
  {
    code: 5913,
    description: "Retorno de mercadoria ou bem recebido p\/ demonstração"
  },
  {
    code: 5914,
    description: "Remessa de mercadoria ou bem p\/ exposição ou feira"
  },
  {
    code: 5915,
    description: "Remessa de mercadoria ou bem p\/ conserto ou reparo"
  },
  {
    code: 5916,
    description: "Retorno de mercadoria ou bem recebido p\/ conserto ou reparo"
  },
  {
    code: 5917,
    description: "Remessa de mercadoria em consignação mercantil ou industrial"
  },
  {
    code: 5918,
    description: "Devolução de mercadoria recebida em consignação mercantil ou industrial"
  },
  {
    code: 5919,
    description: "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, recebida anteriormente em consignação mercantil ou industrial"
  },
  {
    code: 5921,
    description: "Devolução de vasilhame ou sacaria"
  },
  {
    code: 5923,
    description: "Remessa de mercadoria por conta e ordem de terceiros, em venda à ordem ou em operações com armazém geral ou depósito fechado."
  },
  {
    code: 5924,
    description: "Remessa p\/ industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    code: 5925,
    description: "Retorno de mercadoria recebida p\/ industrialização por conta e ordem do adquirente da mercadoria, quando aquela não transitar pelo estabelecimento do adquirente"
  },
  {
    code: 5933,
    description: "Prestação de serviço tributado pelo Imposto Sobre Serviços de Qualquer Natureza"
  },
  {
    code: 5934,
    description: "Remessa simbólica de mercadoria depositada em armazém geral ou depósito fechado."
  },
  {
    code: 6101,
    description: "Venda de produção do estabelecimento"
  },
  {
    code: 6102,
    description: "Venda de mercadoria adquirida ou recebida de terceiros"
  },
  {
    code: 6103,
    description: "Venda de produção do estabelecimento, efetuada fora do estabelecimento"
  },
  {
    code: 6104,
    description: "Venda de mercadoria adquirida ou recebida de terceiros, efetuada fora do estabelecimento"
  },
  {
    code: 6105,
    description: "Venda de produção do estabelecimento que não deva por ele transitar"
  },
  {
    code: 6106,
    description: "Venda de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar"
  },
  {
    code: 6107,
    description: "Venda de produção do estabelecimento, destinada a não contribuinte"
  },
  {
    code: 6108,
    description: "Venda de mercadoria adquirida ou recebida de terceiros, destinada a não contribuinte"
  },
  {
    code: 6111,
    description: "Venda de produção do estabelecimento remetida anteriormente em consignação industrial"
  },
  {
    code: 6112,
    description: "Venda de mercadoria adquirida ou recebida de Terceiros remetida anteriormente em consignação industrial"
  },
  {
    code: 6113,
    description: "Venda de produção do estabelecimento remetida anteriormente em consignação mercantil"
  },
  {
    code: 6114,
    description: "Venda de mercadoria adquirida ou recebida de terceiros remetida anteriormente em consignação mercantil"
  },
  {
    code: 6115,
    description: "Venda de mercadoria adquirida ou recebida de terceiros, recebida anteriormente em consignação mercantil"
  },
  {
    code: 6116,
    description: "Venda de produção do estabelecimento originada de encomenda p\/ entrega futura"
  },
  {
    code: 6117,
    description: "Venda de mercadoria adquirida ou recebida de terceiros, originada de encomenda p\/ entrega futura"
  },
  {
    code: 6118,
    description: "Venda de produção do estabelecimento entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem"
  },
  {
    code: 6119,
    description: "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário por conta e ordem do adquirente originário, em venda à ordem"
  },
  {
    code: 6120,
    description: "Venda de mercadoria adquirida ou recebida de terceiros entregue ao destinatário pelo vendedor remetente, em venda à ordem"
  },
  {
    code: 6122,
    description: "Venda de produção do estabelecimento remetida p\/ industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente"
  },
  {
    code: 6123,
    description: "Venda de mercadoria adquirida ou recebida de terceiros remetida p\/ industrialização, por conta e ordem do adquirente, sem transitar pelo estabelecimento do adquirente"
  },
  {
    code: 6129,
    description: "Venda de insumo importado e de mercadoria industrializada sob o amparo do Regime Aduaneiro Especial de Entreposto Industrial (Recof-Sped)"
  },
  {
    code: 6151,
    description: "Transferência de produção do estabelecimento"
  },
  {
    code: 6152,
    description: "Transferência de mercadoria adquirida ou recebida de terceiros"
  },
  {
    code: 6155,
    description: "Transferência de produção do estabelecimento, que não deva por ele transitar"
  },
  {
    code: 6156,
    description: "Transferência de mercadoria adquirida ou recebida de terceiros, que não deva por ele transitar"
  },
  {
    code: 6201,
    description: "Devolução de compra p\/ industrialização ou produção rural"
  },
  {
    code: 6202,
    description: "Devolução de compra p\/ comercialização"
  },
  {
    code: 6206,
    description: "Anulação de valor relativo a aquisição de serviço de transporte"
  },
  {
    code: 6208,
    description: "Devolução de mercadoria recebida em transferência p\/ industrialização ou produção rural "
  },
  {
    code: 6209,
    description: "Devolução de mercadoria recebida em transferência p\/ comercialização"
  },
  {
    code: 6210,
    description: "Devolução de compra p\/ utilização na prestação de serviço"
  },
  {
    code: 6401,
    description: "Venda de produção do estabelecimento quando o produto sujeito a ST"
  },
  {
    code: 6402,
    description: "Venda de produção do estabelecimento de produto sujeito a ST, em operação entre contribuintes substitutos do mesmo produto"
  },
  {
    code: 6403,
    description: "Venda de mercadoria adquirida ou recebida de terceiros em operação com mercadoria sujeita a ST, na condição de contribuinte substituto"
  },
  {
    code: 6404,
    description: "Venda de mercadoria sujeita a ST, cujo imposto já tenha sido retido anteriormente"
  },
  {
    code: 6408,
    description: "Transferência de produção do estabelecimento quando o produto sujeito a ST"
  },
  {
    code: 6409,
    description: "Transferência de mercadoria adquirida ou recebida de terceiros, sujeita a ST"
  },
  {
    code: 6410,
    description: "Devolução de compra p\/ industrialização ou ptrodução rural quando a mercadoria sujeita a ST"
  },
  {
    code: 6411,
    description: "Devolução de compra p\/ comercialização em operação com mercadoria sujeita a ST"
  },
  {
    code: 6412,
    description: "Devolução de bem do ativo imobilizado, em operação com mercadoria sujeita a ST"
  },
  {
    code: 6413,
    description: "Devolução de mercadoria destinada ao uso ou consumo, em operação com mercadoria sujeita a ST"
  },
  {
    code: 6414,
    description: "Remessa de produção do estabelecimento p\/ venda fora do estabelecimento, quando o produto sujeito a ST"
  },
  {
    code: 6415,
    description: "Remessa de mercadoria adquirida ou recebida de terceiros p\/ venda fora do estabelecimento, quando a referida ração com mercadoria sujeita a ST"
  },
  {
    code: 6501,
    description: "Remessa de produção do estabelecimento, com fim específico de exportação"
  },
  {
    code: 6502,
    description: "Remessa de mercadoria adquirida ou recebida de terceiros, com fim específico de exportação"
  },
  {
    code: 6503,
    description: "Devolução de mercadoria recebida com fim específico de exportação"
  },
  {
    code: 6504,
    description: "Remessa de mercadoria p\/ formação de lote de exportação, de produto industrializado ou produzido pelo próprio estabelecimento."
  },
  {
    code: 6505,
    description: "Remessa de mercadoria, adquirida ou recebida de terceiros, p\/ formação de lote de exportação."
  },
  {
    code: 6551,
    description: "Venda de bem do ativo imobilizado"
  },
  {
    code: 6553,
    description: "Devolução de compra de bem p\/ o ativo imobilizado"
  },
  {
    code: 6554,
    description: "Remessa de bem do ativo imobilizado p\/ uso fora do estabelecimento"
  },
  {
    code: 6555,
    description: "Devolução de bem do ativo imobilizado de terceiro, recebido p\/ uso no estabelecimento"
  },
  {
    code: 6556,
    description: "Devolução de compra de material de uso ou consumo"
  },
  {
    code: 6557,
    description: "Transferência de material de uso ou consumo"
  },
  {
    code: 6603,
    description: "Ressarcimento de ICMS retido por substituição tributária"
  },
  {
    code: 6901,
    description: "Remessa p\/ industrialização por encomenda"
  },
  {
    code: 6902,
    description: "Retorno de mercadoria utilizada na industrialização por encomenda"
  },
  {
    code: 6903,
    description: "Retorno de mercadoria recebida p\/ industrialização e não aplicada no referido processo"
  },
  {
    code: 6904,
    description: "Remessa p\/ venda fora do estabelecimento"
  },
  {
    code: 6906,
    description: "Retorno de mercadoria depositada em depósito fechado ou armazém geral"
  },
  {
    code: 6907,
    description: "Retorno simbólico de mercadoria depositada em depósito fechado ou armazém geral"
  },
  {
    code: 6908,
    description: "Remessa de bem por conta de contrato de comodato"
  },
  {
    code: 6909,
    description: "Retorno de bem recebido por conta de contrato de comodato"
  },
  {
    code: 6910,
    description: "Remessa em bonificação, doação ou brinde"
  },
  {
    code: 6911,
    description: "Remessa de amostra grátis"
  },
  {
    code: 6912,
    description: "Remessa de mercadoria ou bem p\/ demonstração"
  },
  {
    code: 6913,
    description: "Retorno de mercadoria ou bem recebido p\/ demonstração"
  },
  {
    code: 6914,
    description: "Remessa de mercadoria ou bem p\/ exposição ou feira"
  },
  {
    code: 6915,
    description: "Remessa de mercadoria ou bem p\/ conserto ou reparo"
  },
  {
    code: 6916,
    description: "Retorno de mercadoria ou bem recebido p\/ conserto ou reparo"
  },
  {
    code: 6917,
    description: "Remessa de mercadoria em consignação mercantil ou industrial"
  },
  {
    code: 6918,
    description: "Devolução de mercadoria recebida em consignação mercantil ou industrial"
  },
  {
    code: 6919,
    description: "Devolução simbólica de mercadoria vendida ou utilizada em processo industrial, recebida anteriormente em consignação mercantil ou industrial"
  },
  {
    code: 6921,
    description: "Devolução de vasilhame ou sacaria"
  },
  {
    code: 6923,
    description: "Remessa de mercadoria por conta e ordem de terceiros, em venda à ordem ou em operações com armazém geral ou depósito fechado"
  },
  {
    code: 6924,
    description: "Remessa p\/ industrialização por conta e ordem do adquirente da mercadoria, quando esta não transitar pelo estabelecimento do adquirente"
  },
  {
    code: 6925,
    description: "Retorno de mercadoria recebida p\/ industrialização por conta e ordem do adquirente da mercadoria, quando aquela não transitar pelo estabelecimento do adquirente"
  },
  {
    code: 6933,
    description: "Prestação de serviço tributado pelo Imposto Sobre Serviços de Qualquer Natureza "
  },
  {
    code: 6934,
    description: "Remessa simbólica de mercadoria depositada em armazém geral ou depósito fechado"
  },
];

export const ICMSORIGIN = [
  {
    code: '0'
  },
  {
    code: '1'
  }
];

export const PAYMENTSMETHOD = {
  boleto: {
    id: 'bee44eb9-430a-4046-973d-710ecad04775',
    name: 'Boleto'
  },
  concessionarias: {
    id: 'bf7cc622-4e43-4c4a-93cc-745536a13043',
    name: 'Concessionárias'
  },
  debitoAutomatico: {
    id: '5c39c4df-26a8-4526-9864-e2864c68fb08',
    name: 'Débito Automático'
  },
  pix: {
    id: '6255943a-e4ea-4af2-b0cb-e43b002808e9',
    name: 'PIX'
  },
  ted: {
    id: 'b5975e87-6475-47e5-839b-6292e9d36b00',
    name: 'TED'
  },
  transferenciaEntreContas: {
    id: 'd6da5275-d074-4188-88cb-580efba63583',
    name: 'Transferência entre contas'
  },
  transferenciaPix: {
    id: 'ef947822-8af8-41de-a85a-52e44485445d',
    name: 'Transferência PIX'
  },
  tributos: {
    id: 'aef312e7-0112-4dbd-8b2a-f24d7753dda9',
    name: 'Tributos'
  },
  boletoPix: {
    id: '16d9746a-fbe3-4f0f-a804-71a9ee3018b3',
    name: 'Boleto Pix',
  },
};
export const TYPEBUYER = [
  {
    id: '0',
    name: 'Fornecedor'
  },
  {
    id: '1',
    name: 'Locais'
  }
];

// Helpers para converter
export const MOVEMENT_TYPE_LIST = Object.keys(MOVEMENTTYPEFILTER).map(key => ({
  id: MOVEMENTTYPEFILTER[key].id,
  name: MOVEMENTTYPEFILTER[key].title,
  active: true
}));

export const MOVEMENT_STEP_LIST = Object.keys(MOVEMENTSTEPFILTER).map(key => ({
  id: MOVEMENTSTEPFILTER[key].id,
  name: MOVEMENTSTEPFILTER[key].title,
  active: true
}));